{
  "endTime": "Hora final",
  "startTime": "Hora inicial",
  "time": "Hora"
}
